import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle, faSearch, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { useMainContext } from "../../../../contexts/MainContext";

//ACTIONS AND CONTEXT
import ModalAddImport from '../../../../components/atoms/ModalAddImport';
import Dropdown from "../../../../components/atoms/Dropdown";
var _ = require('lodash');

/**
    * Componente SearchImportFilters
    * @component
    * @param  props
    * 
*/
const SearchImportFilters = ({ }) => {
    const [showModal, setShowModal] = useState(false);
    let mainContext = useMainContext();

    const closeModal = () => {
        setShowModal(false)
        mainContext.setIsLoading(false);
    }
    return (
        <>
            <ModalAddImport showModal={showModal} setShow={closeModal} />
            <div className="content-filters">
                <div className="content-filters-left">
                    <div id="contentSearchBar">
                        <label><b>Nombre de la importación</b></label>
                        <div id="search">
                            <button type="submit" id="searchButton">
                                <span className="iconSearch">
                                    <FontAwesomeIcon icon={faSearch} />
                                </span>
                            </button>
                            <input type="text" id="inputSearch" placeholder="Nombre" />
                        </div>
                    </div>
                    <div className="select-filter">
                        <label><b>País</b></label>
                        <Dropdown optionLabel="countryName" optionValue="countryID" />
                    </div>
                    <div className="select-filter position-relative">
                        <div className="mr-3">
                            <label className="po"><b>Zona Metropolitana</b></label>
                            <Dropdown optionLabel="municipalityName" optionValue="municipalityID" />
                        </div>
                    </div>
                    <div className="w-100px pt-3">
                        <span className="btn-icon mt-3 mr-3"><FontAwesomeIcon size="2x" icon={faSearch} /></span>
                        <span className="btn-icon mt-3"><FontAwesomeIcon size="2x" icon={faTimesCircle} /></span>
                    </div>
                </div>
                <div className="content-filters-right">
                    <button className="buttonAdd btn-icon tooltip" onClick={() => { setShowModal(true) }}>
                        <span className="mt-3"><FontAwesomeIcon size="2x" icon={faPlusCircle} /></span>
                        <span className="tooltiptext">Agregar Importación</span>
                    </button>
                </div>
            </div>
        </>
    )
}
export default SearchImportFilters;